module.exports = __webpack_public_path__ + "img/amazon.fr.9be731aa.jpg";